module.exports = __webpack_public_path__ + "media/images/countryrect/bh-37a1ee28f5b8b6cc8fa264422ed1fcbd.svg";